'use client';

import { Box, Skeleton } from '@chakra-ui/react';

const BannerListSkeleton = () => {
  return (
    <Box width="100%" height="100%" position="relative">
      <Skeleton width="100%" height="100%" borderRadius="0" />
    </Box>
  );
};

export default BannerListSkeleton;
